// extracted by mini-css-extract-plugin
export var content = "_r3-1";
export var fullScreen = "_r3-0";